import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { DataModeProvider } from './contexts/DataModeContext';
import { LanguageProvider } from './components/LanguageProvider';
import { ToastProvider } from './components/notifications/ToastProvider';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import PilotClientRoute from './components/PilotClientRoute';
import MainLayout from './components/layout/MainLayout';
import DashboardPageUnified from './pages/DashboardPageUnified';
import PropertiesPage from './pages/PropertiesPage';
import PropertyVisualizerPage from './pages/PropertyVisualizerPage';
import TenantsPage from './pages/TenantsPage';
import OwnersPage from './pages/OwnersPage';
import SuppliersPage from './pages/SuppliersPage';
import MaintenancePage from './pages/MaintenancePage';
import ComplianceHubPage from './pages/ComplianceHubPage';
import DocumentsPage from './pages/DocumentsPage';
import AnalyticsPage from './pages/AnalyticsPage';
import SettingsPage from './pages/SettingsPage';
import UserSettingsPage from './pages/UserSettingsPage';
import ActivityPage from './pages/ActivityPage';
import BankingPage from './pages/BankingPage';
import TransactionReviewPage from './pages/TransactionReviewPage';
import FinancingPage from './pages/FinancingPage';
import SteuernPage from "./pages/SteuernPage";
import UtilityBillingPage from './pages/UtilityBillingPage';
import NkArchivePage from './pages/NkArchivePage';
import NkBillingPreviewPage from './pages/NkBillingPreviewPage';
import BewirtschaftungPage from './pages/BewirtschaftungPage';
import WEGManagementPage from './pages/WEGManagementPage';
import ContractManagementPage from './pages/ContractManagementPage';
import EnergyContractHubPage from './pages/EnergyContractHubPage';
import SignaturenPage from './pages/SignaturenPage';
import TabletWizard from './pages/TabletWizard';
import LeaseAdjustments from './pages/LeaseAdjustments';
import PropertyValuation from './pages/PropertyValuation';
import BankReport from './pages/BankReport';
import VPSDashboard from './pages/VPSDashboard';
import PromptVaultPage from './pages/PromptVaultPage';
import CommunicationPage from './pages/CommunicationPage';
import ManifestPage from './pages/ManifestPage';
import VitalCenterPage from './pages/VitalCenterPage';
          import ClaraKIPage from './pages/ClaraKIPage';
import ClaraAISearch from './pages/ClaraAISearch';
import ClaraIoTPage from './pages/clara-iot/ClaraIoTPage';
import OAuthCallback from './components/OAuthCallback';
import OAuthCallbackPage from './pages/OAuthCallbackPage';
import LoginPage from './pages/LoginPage';
import RegionaleInsightsPage from "./RegionaleInsightsPage_ENHANCED";
import RegisterPage from './pages/RegisterPage';
import PilotRequestPage from './pages/PilotRequestPage';
import MieterPage from './pages/MieterPage';
import VPIFrontendTest from './components/VPI_Frontend_Test';
import BriefingCanvas from './components/briefing/BriefingCanvas';
import InvestmentCockpit from './pages/InvestmentCockpit';
import PerformanceReportPage from './pages/PerformanceReportPage';
import TenantPortal from './pages/tenant-portal/TenantPortal';
import RealOnboardingSystem from './components/RealOnboardingSystem';
import MarketplacePage from './pages/MarketplacePage';
import SharedEconomyPage from './pages/SharedEconomyPage';
import SharedEconomyLanding from "./pages/SharedEconomyLanding";
import SharedEconomyCaring from './pages/SharedEconomyCaring';
import PortfolioPage from './pages/PortfolioPage';
import FloorplanEditorPage from './pages/FloorplanEditorPage';
import InteractiveReportPage from './pages/InteractiveReportPage';
import RentTrackingPage from './components/finance/RentTrackingPage';
import RentNkHistoryPage from './pages/RentNkHistoryPage';

function App() {
  return (
    <AuthProvider>
      <ToastProvider>
      <ThemeProvider>
        <DataModeProvider>
          <LanguageProvider>
            <Router>
              <Routes>
                {/* Public Routes */}
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                    <Route path="/mieter" element={<MieterPage />} />
          <Route path="/pilot" element={<PilotRequestPage />} />
                <Route path="/onboarding" element={<RealOnboardingSystem />} />
                <Route path="/oauth/callback" element={<OAuthCallback />} />
                <Route path="/oauth/outlook/callback" element={<OAuthCallbackPage />} />
                
                {/* Interactive Report - Public (with optional password protection) */}
                <Route path="/reports/:reportId" element={<InteractiveReportPage />} />
                
                {/* Protected Routes with MainLayout - OUTLET STRUCTURE */}
                <Route path="/" element={
                  <ProtectedRoute>
                    <MainLayout />
                  </ProtectedRoute>
                }>
                  {/* Nested Routes - NO <Routes> wrapper */}
                  <Route index element={<DashboardPageUnified />} />
                  <Route path="dashboard" element={<DashboardPageUnified />} />
                  <Route path="clara-ki" element={<ClaraKIPage />} />
                  <Route path="clara-ai-search" element={<ClaraAISearch />} />
                                    <Route path="marketplace" element={<MarketplacePage />} />
                  <Route path="clara-iot" element={<ClaraIoTPage />} />
                  {/* PILOT_CLIENT: ❌ gesperrt — Finanzmodule */}
                  <Route path="banking" element={<AdminRoute><BankingPage /></AdminRoute>} />
                  <Route path="finanzierungen" element={<PilotClientRoute><FinancingPage /></PilotClientRoute>} />
                  <Route path="steuern" element={<PilotClientRoute><SteuernPage /></PilotClientRoute>} />
                  <Route path="mieteingangskontrolle" element={<PilotClientRoute><RentTrackingPage /></PilotClientRoute>} />
                  <Route path="miet-nk-historie" element={<PilotClientRoute><RentNkHistoryPage /></PilotClientRoute>} />
                  <Route path="shared-economy" element={<PilotClientRoute><SharedEconomyPage /></PilotClientRoute>} />
          <Route path="shared-economy/landing" element={<PilotClientRoute><SharedEconomyLanding /></PilotClientRoute>} />
          <Route path="shared-economy/caring" element={<PilotClientRoute><SharedEconomyCaring /></PilotClientRoute>} />
          <Route path="portfolio" element={<PilotClientRoute><PortfolioPage /></PilotClientRoute>} />
                  {/* PILOT_CLIENT: ❌ gesperrt — Eigentümer & WEG */}
                  <Route path="owners" element={<PilotClientRoute><OwnersPage /></PilotClientRoute>} />
                  <Route path="hoa-management" element={<PilotClientRoute><WEGManagementPage /></PilotClientRoute>} />
                  {/* PILOT_CLIENT: ✅ erlaubt */}
                  <Route path="tenants" element={<TenantsPage />} />
                  <Route path="suppliers" element={<PilotClientRoute><SuppliersPage /></PilotClientRoute>} />
                  {/* PILOT_CLIENT: ✅ erlaubt */}
                  <Route path="properties" element={<PropertiesPage />} />
                  <Route path="property-visualizer" element={<PilotClientRoute><PropertyVisualizerPage /></PilotClientRoute>} />
                  <Route path="grundriss-editor" element={<PilotClientRoute><FloorplanEditorPage /></PilotClientRoute>} />
                  {/* PILOT_CLIENT: ✅ erlaubt (nur lesend) */}
                  <Route path="bewirtschaftung" element={<BewirtschaftungPage />} />
                  <Route path="utility-billing" element={<AdminRoute><UtilityBillingPage /></AdminRoute>} />
                  <Route path="utility-billing/abrechnungen" element={<AdminRoute><NkArchivePage /></AdminRoute>} />
                  <Route path="utility-billing/abrechnungen/probe" element={<AdminRoute><NkBillingPreviewPage /></AdminRoute>} />
                  {/* PILOT_CLIENT: ❌ gesperrt — interne Tools */}
                  <Route path="activities" element={<PilotClientRoute><ActivityPage /></PilotClientRoute>} />
                  <Route path="maintenance" element={<PilotClientRoute><MaintenancePage /></PilotClientRoute>} />
                  <Route path="compliance-hub" element={<PilotClientRoute><ComplianceHubPage /></PilotClientRoute>} />
                  <Route path="tenant-portal" element={<PilotClientRoute><TenantPortal /></PilotClientRoute>} />
                  {/* PILOT_CLIENT: ✅ erlaubt */}
                  <Route path="documents" element={<DocumentsPage />} />
                  <Route path="contract-management" element={<PilotClientRoute><ContractManagementPage /></PilotClientRoute>} />
                  <Route path="energy-contract-hub" element={<EnergyContractHubPage />} />
                  <Route path="signaturen" element={<PilotClientRoute><SignaturenPage /></PilotClientRoute>} />
                  <Route path="signaturen/tablet" element={<PilotClientRoute><TabletWizard /></PilotClientRoute>} />
                  {/* PILOT_CLIENT: ❌ gesperrt — Finanzauswertungen */}
                  <Route path="analytics" element={<PilotClientRoute><AnalyticsPage /></PilotClientRoute>} />
                  <Route path="lease-adjustments" element={<PilotClientRoute><LeaseAdjustments /></PilotClientRoute>} />
                  <Route path="property-valuation" element={<PilotClientRoute><PropertyValuation /></PilotClientRoute>} />
                  <Route path="bank-report" element={<PilotClientRoute><BankReport /></PilotClientRoute>} />
                  <Route path="investment-cockpit" element={<PilotClientRoute><InvestmentCockpit /></PilotClientRoute>} />
                  <Route path="performance-report" element={<PilotClientRoute><PerformanceReportPage /></PilotClientRoute>} />
                  {/* PILOT_CLIENT: ❌ gesperrt */}
                  <Route path="regionale-insights" element={<PilotClientRoute><RegionaleInsightsPage /></PilotClientRoute>} />
                  {/* PILOT_CLIENT: ❌ gesperrt — Systemeinstellungen */}
                  <Route path="settings" element={<PilotClientRoute><SettingsPage /></PilotClientRoute>} />
                  {/* PILOT_CLIENT: ✅ erlaubt — eigene Profileinstellungen */}
                  <Route path="user-settings" element={<UserSettingsPage />} />
                  <Route path="vps-dashboard" element={<AdminRoute><VPSDashboard /></AdminRoute>} />
                  <Route path="prompt-vault" element={<AdminRoute><PromptVaultPage /></AdminRoute>} />
                  <Route path="communications" element={<CommunicationPage />} />
                  <Route path="manifest" element={<AdminRoute><ManifestPage /></AdminRoute>} />
                  <Route path="system-manifest" element={<AdminRoute><ManifestPage /></AdminRoute>} />
                  <Route path="vital-center" element={<AdminRoute><VitalCenterPage /></AdminRoute>} />
                  <Route path="vpi-test" element={<AdminRoute><VPIFrontendTest /></AdminRoute>} />
                  <Route path="morning-briefing" element={<BriefingCanvas />} />
                </Route>
              </Routes>
            </Router>
          </LanguageProvider>
        </DataModeProvider>
      </ThemeProvider>
      </ToastProvider>
    </AuthProvider>
  );
}

export default App;
